import React from 'react';
import LibraryPostsView from '../views/libraryposts/LibraryPostsView';
import CardContainer from './CardContainer';
import * as LibraryPostsSelector from '../../data/LibraryPostsSelector';


const LibraryPostsContainer = (props) => {
	const libraryPostsCardModel = LibraryPostsSelector.getLibraryPosts();
	return (
		<CardContainer
			cardName="Library News"
			cardModel={libraryPostsCardModel}
			component={LibraryPostsView}
			onItemClick={props.onItemClick}
			{...props}
		/>
	);
}

export default LibraryPostsContainer;



// WEBPACK FOOTER //
// ./src/react/containers/LibraryPostsContainer.jsx